//export const setLanguagePairs = (pairs) => {
export const fetchLanguagePairs = (pairs) => {
  // Return action
  return {
    // Unique identifier
    type: 'GET_PAIRS',
	pairs: pairs
  }
};